<template>
  <div class="modals--cookies-modal modal">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card">
          <header class="modal-card-head has-background-white">
            <p class="modal-card-title has-text-centered">
              {{ $t('wistro.cookies.cookie_settings') }}
            </p>
            <span class="delete" aria-label="close" @click="close"></span>
          </header>
          <section class="modal-card-body">

            <p>{{ $t('wistro.cookies.info') }}</p>

            <div class="pt-3">
              <span class="tag is-success is-light is-pulled-right">{{ $t('wistro.cookies.required') }}</span>
              <p class="has-text-weight-bold">{{ $t('wistro.cookies.types.required.name') }}</p>
            </div>

            <span class="button is-small is-light" @click="basicDetails = !basicDetails">
              <span v-if="basicDetails">{{ $t('wistro.cookies.actions.hide_details') }}</span>
              <span v-else>{{ $t('wistro.cookies.actions.show_details') }}</span>
            </span>

            <div class="pt-1" v-if="basicDetails">
              <p class="is-size-7">
                {{ $t('wistro.cookies.types.required.description') }}
              </p>
              <table class="table is-size-7 is-fullwidth">
                <thead>
                  <tr>
                    <th>{{ $t('wistro.cookies.cookies_identifier') }}</th>
                    <th>{{ $t('wistro.cookies.cookies_description') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>{{ laravelSession }}</strong></td>
                    <td>{{ $t('wistro.cookies.cookies.laravel_session') }}</td>
                  </tr>
                  <tr>
                    <td><strong>XSRF-TOKEN</strong></td>
                    <td>{{ $t('wistro.cookies.cookies.XSRF_TOKEN') }}</td>
                  </tr>
                  <tr>
                    <td><strong>cookies_consent</strong></td>
                    <td>{{ $t('wistro.cookies.cookies.cookies_consent') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pt-3">
              <b-switch type="is-success" class="is-pulled-right" v-model="analyticsForm" />
              <p class="has-text-weight-bold">{{ $t('wistro.cookies.types.analytics.name') }}</p>
            </div>

            <span class="button is-small is-light" @click="analyticsDetails = !analyticsDetails">
              <span v-if="analyticsDetails">{{ $t('wistro.cookies.actions.hide_details') }}</span>
              <span v-else>{{ $t('wistro.cookies.actions.show_details') }}</span>
            </span>

            <div class="pt-1" v-if="analyticsDetails">
              <p class="is-size-7">
                {{ $t('wistro.cookies.types.analytics.description') }}
              </p>
              <table class="table is-size-7 is-fullwidth">
                <thead>
                  <tr>
                    <th>{{ $t('wistro.cookies.cookies_identifier') }}</th>
                    <th>{{ $t('wistro.cookies.cookies_description') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>_ga</strong></td>
                    <td>{{ $t('wistro.cookies.cookies._ga') }}</td>
                  </tr>
                  <tr>
                    <td><strong>_gid</strong></td>
                    <td>{{ $t('wistro.cookies.cookies._gid') }}</td>
                  </tr>
                  <tr>
                    <td><strong>_gat</strong>[*]</td>
                    <td>{{ $t('wistro.cookies.cookies._gat') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pt-3" v-if="!facebookPixel">
              <span class="tag is-light is-pulled-right">{{ $t('wistro.cookies.not_used') }}</span>
              <p class="has-text-weight-bold">{{ $t('wistro.cookies.types.marketing.name') }}</p>
            </div>

            <template v-else>
              <div class="pt-3">
                <b-switch type="is-success" class="is-pulled-right" v-model="marketingForm" />
                <p class="has-text-weight-bold">{{ $t('wistro.cookies.types.marketing.name') }}</p>
              </div>

              <span class="button is-small is-light" @click="marketingDetails = !marketingDetails">
                <span v-if="marketingDetails">{{ $t('wistro.cookies.actions.hide_details') }}</span>
                <span v-else>{{ $t('wistro.cookies.actions.show_details') }}</span>
              </span>

              <div class="pt-1" v-if="marketingDetails">
                <p class="is-size-7">
                  {{ $t('wistro.cookies.types.marketing.description') }}
                </p>
                <table class="table is-size-7 is-fullwidth">
                  <thead>
                    <tr>
                      <th>{{ $t('wistro.cookies.cookies_identifier') }}</th>
                      <th>{{ $t('wistro.cookies.cookies_description') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>_fbp</strong></td>
                      <td>{{ $t('wistro.cookies.cookies._fbp') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

            <p class="pt-2" v-html="$t('wistro.cookies.more', {url: cookiesUrl})"></p>

          </section>
          <footer class="modal-card-foot has-background-white">
            <div class="is-flex is-flex-direction-row is-justify-content-space-between is-width-100 is-flex-wrap-wrap">
              <button
                  class="button is-success my-1"
                  :class="{'is-loading': loadingSelected}"
                  @click="acceptSelected"
              >{{ $t('wistro.cookies.actions.accept_selected') }}</button>
              <button
                  class="button is-success my-1"
                  :class="{'is-loading': loadingAll}"
                  @click="acceptAll"
              >{{ $t('wistro.cookies.actions.accept_all') }}</button>
            </div>
          </footer>
      </div>
  </div>
</template>

<script>
import cookieActions from '../../../store/web/cookie/action-types';
import cookieGetters from '../../../store/web/cookie/getter-types';

export default {
  props: {
    laravelSession: String,
    cookiesUrl: String,
  },
  data() {
    return {
      basicDetails: false,
      analyticsDetails: false,
      marketingDetails: false,
      analyticsForm: false,
      marketingForm: false,
      loadingAll: false,
      loadingSelected: false,
    }
  },
  methods: {
    acceptAll() {
      this.loadingAll = true;
      this.$store.dispatch('cookie/' + cookieActions.ACCEPT_ALL).then(() => {
        this.close();
        this.analyticsForm = true;
        this.marketingForm = true;
        this.loadingAll = false;
      });
    },
    acceptSelected() {
      this.loadingSelected = true;
      let payload = {
        analytics: this.analyticsForm,
        marketing: this.marketingForm
      }
      this.$store.dispatch('cookie/' + cookieActions.ACCEPT_SELECTED, payload).then(() => {
        this.close();
        this.loadingSelected = false;
      });
    },
    close() {
      $('html').removeClass('is-clipped');
      $('.modals--cookies-modal').removeClass('is-active');
    }
  },
  computed: {
    facebookPixel() {
      return this.$store.getters['cookie/' + cookieGetters.GET_FACEBOOK_PIXEL];
    },
    analytics() {
      return this.$store.getters['cookie/' + cookieGetters.GET_ANALYTICS];
    },
    marketing() {
      return this.$store.getters['cookie/' + cookieGetters.GET_MARKETING];
    }
  },
  watch: {
    analytics(value) {
      this.analyticsForm = value;
    },
    marketing(value) {
      this.marketingForm = value;
    }
  }
}
</script>

<style>

</style>
